import type { WhitelistItem } from "@gearbox-protocol/cli-utils";
import type { FC } from "react";
import { WhitelistListItem } from "./WhitelistListItem";

interface WhitelistListProps {
  items: WhitelistItem[];
  onDelete: (item: WhitelistItem) => void;
  className?: string;
}

const WhitelistList: FC<WhitelistListProps> = ({
  items,
  className,
  onDelete,
}) => {
  return (
    <table className={className}>
      <tbody>
        {items.map(f => (
          <WhitelistListItem
            key={`${f.network}-${f.address}`}
            item={f}
            onDelete={onDelete}
          />
        ))}
      </tbody>
    </table>
  );
};

export default WhitelistList;
